import React from "react";
import { Typography, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { InfoMessage } from "../alerts/InfoMessage.js";
import "../alerts/NoAccessInfoMessage.js";
import "../alerts/Message.style.js";
import { LocalizedText } from "../i18n/LocalizedText.js";
import "../alerts/InfoAlert.js";
import "../alerts/InfoMessageHoc.js";
import { LinkText } from "../link/LinkText.js";
import "../link/LinkButton.js";
import { ErrorDetails } from "./ErrorDetails.js";
import { localized } from "./localize.js";
const useClasses = makeStyles()(() => ({
  errorAccordion: {
    background: "transparent",
    boxShadow: "none"
  },
  errorAccordionSummary: {
    "& .MuiAccordionSummary-content": {
      justifyContent: "center"
    }
  }
}));
function ErrorAccordion(props) {
  const { classes } = useClasses();
  return /* @__PURE__ */ React.createElement(InfoMessage, null, /* @__PURE__ */ React.createElement(Typography, { variant: "body1" }, /* @__PURE__ */ React.createElement(LocalizedText, { label: localized.infoMessage })), /* @__PURE__ */ React.createElement(Accordion, { className: classes.errorAccordion }, /* @__PURE__ */ React.createElement(AccordionSummary, { className: classes.errorAccordionSummary }, /* @__PURE__ */ React.createElement(LinkText, { title: localized.showMoreLabel, onClick: () => {
  } })), /* @__PURE__ */ React.createElement(AccordionDetails, null, /* @__PURE__ */ React.createElement(ErrorDetails, { ...props }))));
}
export {
  ErrorAccordion,
  useClasses
};
//# sourceMappingURL=ErrorAccordion.js.map
